import {
    VuexModule,
   Module,
   getModule,
   Mutation,
   Action,
   } from 'vuex-module-decorators';
   import store from '@/store';
   import AuthModule from '@/store/AuthModule';
   
   interface FiltersState {
   show: boolean;
   privateMode: boolean;
   }
   
   @Module({ dynamic: true, store, name: 'filters', namespaced: true })
   class FiltersModule extends VuexModule implements FiltersState {
   public show = true;
   public privateMode = false;
   // Program object behind filters.program, so every search box can display it
   public selectedProgram: any = null;
   public filters: any = {
   status: '',
   profitabilityMin: null,      
   includeProfitabilityMin: false,   
   includeNoProfitability: false,
   dateInterval: [40, 64],
   dateIntervalFinBail: [0, 80],
   includeUsufruitDuration: false,
   usufruitDuration: [1, 30],
   dureeUsufruitInterval: [null, null],
   includeNuePro: false,
   nuePro: [30, 90],
   dureeNueProInterval: [null, null],
   includeBailDuration: false,
   bailDurationInterval: [0, 20],
   bailDurationMin: null,       
   bailDurationMax: null, 
   budget: {
   min: null,
   max: null,
    },
   program: undefined,
   taxes: [],
   types: [],
   types2: [],
   outdoors: [],
   region: undefined,

   country: '',  
   departement: undefined,
   city: undefined,
   cp: undefined,
   timeStep: 1,
   dutyFreeFeeMin: null,
   pinelPlus: false,
   brs: false,
   surfaceInterval: [0, 200],
   surfaceStep: 1,
   surfaceExtInterval: [0, 200],
   surfaceExtStep: 1,
   BuildingCoteInterval: [0, 100],
   BuildingCoteStep: 1,
   includeDutyFree: false,
   profitabilityProgramGtieInterval: [1, 15],
   profitabilityProgramGtieIntervalStep: 1,
   floorStep: 1,
   floorInterval: [1, 9],
   includeFloor:false,
   includeProfitability: false,
   includeDeliveryTrimester: false,
   includeDateFinBail: false,
   includeSurface: false,
   includeExtSurface: false,
   includeBuildingCote: false,
   promotor: undefined,
   type_flux: null,
   statusProgram : AuthModule.roles.includes("ROLE_MANAGER") ? ["to_control","data_processing","diffused"]:['diffused'],
   zones: [],
   rez: null,
   electronic_sign: null,
   commercials: null,
   includeNoDFF: false,
   includeFavorite: false,
   operator: null,
   isLivrable: false,
   isActable: false,

   exposures: []   
    };
   
    @Mutation
   setShow(show: boolean) {
   this.show = show;
    }
   
    @Mutation
   setFilters(filters: any) {
   this.filters = filters;
    }
   
    @Mutation
   setSelectedProgram(program: any) {
   this.selectedProgram = program || null;
    }

    @Mutation
   setPrivateMode(privateMode: boolean) {
   this.privateMode = privateMode;
    }
   
    @Action({ commit: 'setFilters'})
   onFilters(filters: any){
   return filters;
    }
   
    @Action({ commit: 'setShow' })
   async toggleShow() {
   return !this.show;
    }
   
    @Action({ commit: 'setPrivateMode' })
   togglePrivateMode() {
   return !this.privateMode;
    }
   }
   
   export default getModule(FiltersModule);